<template>
  <div class="table-responsive" :class="{ 'tbl-inherit': overflowState }">
    <div class="row">
      <div class="col-sm-3">
        <Alert type="danger" :messages="errors" />
      </div>
    </div>
    <div style="width: 100%; position: relative;">
      <Loader v-show="loading" />
      <table class="table" v-show="!loading" :class="{ 'has-review-date': !isReviewer }" style="table-layout: fixed !important; width: 100%;">
        <ApplicantTableHeader 
          :sort-key="sortKey"
          :asc="asc"
          :client-status="getClientStatus"
          :showReviewListDate="!isReviewer"
          @sort="sorting"
          @search="search"
          @check-all="checkAll"
          @overflow="overflow"
        />
        <tbody>
          <ApplicantRow
            v-for="(applicant, index) in applicants"
            v-bind:key="applicant.id"
            :applicant="applicant"
            :applicantIndex="index"
            :rowNumber="rowNumber(index)"
            @hidden="overflowState = 0"
            @shown="overflow"
            @changed="checkUncheckJobseeker"
          />
          <tr v-if="showEmptyMessage">
            <td colspan="100%" class="text-center">
              登録者が見つかりませんでした
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pagination-area" v-if="totalPages > 1">
      <paginate :total-page="totalPages" :callback="changePage" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import ApplicantRow from '@/components/dashboard/applicants/ApplicantRow.vue';
import ApplicantTableHeader from '@/components/dashboard/applicants/ApplicantTableHeader.vue';
import Loader from '@/components/utils/Loader.vue';
import Paginate from '@/components/utils/Paginate.vue';
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';
import actions from '@/config/actions';
import mutations from '@/config/mutations';
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import Alert from '@/components/utils/Alert.vue';

export default {
  name: 'ApplicantList',
  components: { Paginate, Loader, ApplicantRow, Alert, ApplicantTableHeader },
  data() {
    return {
      sortKey: null,
      asc: true,
      overflowState: 0,
      errors: [],
      perPageRows: ['20件', '50件'],
      selectedLabel: '',
      client_status_list: [
        '未確認',
        '選考対象外',
        '選考対象、未対応',
        '確認中',
        '過去応募済み',
        'コンタクト済み',
        '返信有',
        // 'プッシュ済',

        // '応募有',
        '選考応募有',
        'システム取込み済み',

        '選考NG',
        '中長期的対応',
        'その他',
      ],
      showEmptyMessage: false,
      clientSortBy: null, // Track sort direction for client-side sorting
    };
  },
  async created() {
    try {
      if (this.mainJobModel.length > 0) {
        this.mainJobModelChanged(this.mainJobModel);
        this.search();
      }

      if (this.mainJobModel.length === 0 && this.defaultLoaded) {
        await this.load(this.buildParams(1));
      }
      this.loadMenuConfigurations();
    } catch (error) {
      // Handle any errors that might occur during the creation process
      console.error(error);
    }
  },
  computed: {
    ...mapGetters({
      getChildJobModel: 'getChildJobModel',
      getMainJobModel: 'getMainJobModel',
      getEnglishSkillModel: 'getEnglishSkillModel',
      getStatusModel: 'getStatusModel',
      getClientStatus: 'getClientStatus',
      getColorModel: 'getColorModel',
      getClientColor: 'getClientColor',
      getCompanyModel: 'getCompanyModel',
      getMenus: 'getMenus',
      reviewLists: 'getReviewLists',
      isAdmin: 'currentUserIsAdmin',
      isReviewer: 'isCreateReviewUser',
      getReviewListModel: 'getReviewListModel',
      defaultLoaded: 'getDefaultLoaded',
      isJdSearch: 'getIsJdSearch',
      getScoutHope: 'getScoutHope',
    }),
    ...mapState({
      applicants: ({ applicant }) => applicant.applicants,
      pagination: ({ applicant }) => applicant.pagination,
      reloadApplicants: ({ applicant }) => applicant.reloadApplicants,
      applicantStatusTovhFilter: ({ applicant }) =>
        applicant.applicantStatusToFilter,
      loading: ({ applicant }) => applicant.loading,
      isCheckAll: ({ applicant }) => applicant.isCheckAll,
      jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
      activeCategory: ({ applicant }) => applicant.activeCategory,
      favoritesOnly: ({ applicant }) => applicant.favoritesOnly,
      interviewsOnly: ({ applicant }) => applicant.interviewsOnly,
      searchParams: ({ applicant }) => applicant.searchParams,
      sortBy: ({ applicant }) => applicant.sortBy,
      page: ({ applicant }) => applicant.page,
      occupations: ({ applicant }) => applicant.selectors.occupations || [],
      englishSkills: ({ applicant }) => applicant.selectors.englishSkills || [],
    }),
    reviewListModel: {
      get() {
        return this.getReviewListModel;
      },
      set(value) {
        this.setReviewListModel(value);
      },
    },
    mainJobModel: {
      get() {
        return this.getMainJobModel;
      },
      set(value) {
        this.setMainJobModel(value);
      },
    },
    childJobModel: {
      get() {
        return this.getChildJobModel;
      },
      set(value) {
        this.setChildJobModel(value);
      },
    },
    englishSkillModel: {
      get() {
        return this.getEnglishSkillModel;
      },
      set(value) {
        this.setEnglishSkillModel(value);
      },
    },
    statusModel: {
      get() {
        return this.getStatusModel;
      },
      set(value) {
        this.setStatusModel(value);
      },
    },
    colorModel: {
      get() {
        return this.getColorModel;
      },
      set(value) {
        this.setColorModel(value);
      },
    },
    companyModel: {
      get() {
        return this.getCompanyModel;
      },
      set(value) {
        this.setCompanyModel(value);
      },
    },
    scoutHope: {
      get() {
        return this.getScoutHope;
      },
      set(value) {
        this.setScoutHope(value);
      },
    },
    totalPages() {
      const { pagination } = this;
      return pagination.total
        ? Math.ceil(pagination.total / pagination.perPage)
        : 0;
    },
    from() {
      return (
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage +
        1
      );
    },
    to() {
      return (
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage +
        this.applicants.length
      );
    },
    // Computed properties for active arrow states
    isJoinedDateAscActive() {
      if (this.isJdSearch) {
        return this.clientSortBy === 'joinedDate';
      }
      return this.sortBy === 'joinedDate';
    },
    isJoinedDateDescActive() {
      if (this.isJdSearch) {
        return this.clientSortBy === '-joinedDate';
      }
      return this.sortBy === '-joinedDate';
    },
  },
  methods: {
    ...mapActions([
      actions.applicant.LOAD_APPLICANTS,
      'loadMenuConfigurations',
      'loadReviewLists',
    ]),
    ...mapMutations([
      mutations.applicant.SET_APPLICANTS,
      mutations.applicant.CHANGE_SORT_COLUMN,
      mutations.applicant.CHANGE_SEARCH_PARAMS,
      'setCurrentPageApplicants',
      'setApplicantCounts',
      'setPage',
      'setChildJobModel',
      'setMainJobModel',
      'setEnglishSkillModel',
      'setStatusModel',
      'setCompanyModel',
      'mutateApplicantsAfterMultipleStatus',
      'updateMainJobModel',
      'setColorModel',
      'setReviewListModel',
      'mutateApplicantsAfterMultipleReviewList',
      'mutateApplicantsAfterMultipleColor',
      'setCheckAll',
      'setReloadApplicants',
      'setLoading',
      'setPagination',
      'setResetCheckAll',
      'setResetApplicantIds',
      'setScoutHope',
    ]),
    overflow() {
      this.overflowState = 1;
    },
    checkAll() {
      this.setCheckAll(!this.isCheckAll);
    },
    checkUncheckJobseeker(id) {
      const index = this.jobseekerIds.indexOf(id);
      if (index > -1) {
        this.jobseekerIds.splice(index, 1);
      } else {
        this.jobseekerIds.push(id);
      }
    },
    changeStatus(status) {
      this.errors = [];
      if (this.jobseekerIds.length == 0) {
        this.errors.push('登録者が選択されていません');
      } else {
        this.setLoading(true);
        ApiService.put(Api.endpoints.MULTIPLE_STATUS, {
          jobseekerIDs: this.jobseekerIds,
          status: status,
        })
          .then(({ data }) => {
            this.mutateApplicantsAfterMultipleStatus(data.data);
          })
          .catch(({ response }) => this.parseErrorResponse(response))
          .then(() => {
            this.setLoading(false);
            this.jobseekerIds = [];
            this.setCheckAll(false);
          });
      }
    },
    async changePerPage(row) {
      const params = { rowPerPage: row == '20件' ? 20 : 50 };

      if (this.searchParams) Object.assign(params, this.searchParams);
      if (this.sortBy) Object.assign(params, { sortBy: this.sortBy });
      await this.load(params);
    },
    sorting(key) {
      let column = '';
      if (this.sortKey !== null) {
        if (this.sortKey === key) {
          // Toggle between ascending and descending
          this.asc = !this.asc;
          column = this.asc ? key : `-${key}`;
        } else {
          // New column, start with descending
          column = `-${key}`;
          this.asc = false;
        }
      } else {
        // First sort, start with descending
        column = `-${key}`;
        this.asc = false;
      }
      this.sortKey = key;
      
      // Use server-side sorting for all fields (including age and income)
      this[mutations.applicant.CHANGE_SORT_COLUMN](column);
    },  // this.setPage(1);
    async load(params = {}) {
      try {
        this.setLoading(true);
        this.errors = [];
        if (this.isReviewer || this.isAdmin) {
          this.loadReviewLists();
        }

        const { data } = await this[actions.applicant.LOAD_APPLICANTS](params);

        this[mutations.applicant.SET_APPLICANTS](data.data);

        this.setResetCheckAll();

        this.setResetApplicantIds();

        this.setCurrentPageApplicants(data.data);

        this.showEmptyMessage = this.applicants.length === 0;

        this.setPagination(data.meta.pagination || {});
        // this.pagination = data.meta.pagination || {};
        this.showcount();
      } catch (error) {
        console.log(error);
        // this.parseErrorResponse(response);
      } finally {
        // this.loading = false;
        this.setLoading(false);
        this.setReloadApplicants(false);
      }
    },
    buildParams(page = null) {
      const params = {};
      if (page) params.page = page;
      // if (this.activeCategory) params.category = this.activeCategory;
      if (this.pagination.perPage == 50) params.rowPerPage = 50;
      if (this.favoritesOnly) params.favorites = 1;
      if (this.interviewsOnly) params.interviews = 1;
      // console.log(this.searchParams);
      if(this.searchParams && Object.keys(this.searchParams).length > 0){
        Object.assign(params, this.searchParams);
      }
      // console.log(params);

      // if (this.searchParams && Object.keys(this.searchParams).length > 0) {
      //   Object.assign(params, this.searchParams);
      //   params.initialStatusModel = [];
      // } else {
      //   params.initialStatusModel =
      //     this.applicantStatusToFilter === '未確認' ? ['未確認'] : [];
      // }

      // // 🧠 Apply default "未確認" only if applicable and user hasn't selected manually
      // if (isStatusModelUnchanged && this.applicantStatusToFilter === '未確認') {
      //   this.statusModel = ['未確認'];
      // } else if (
      //   this.applicantStatusToFilter === '全て表示' &&
      //   isStatusModelUnchanged
      // ) {
      //   this.statusModel = [];
      // }
      if (this.sortBy) params.sort = this.sortBy;
      params.isNewPanel = true;
      // if(!this.isReviewer) this.setStatusModel(['社内確認待bち']);
      // console.log(params);
      return params;
    },
    changePage(page) {
      this.setPage(page);
      // this.load(this.buildParams(page));
    },
    rowNumber(index) {
      return (
        index +
        1 +
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage
      );
    },
    showcount() {
      this.setApplicantCounts({
        total: this.pagination.total,
        from: this.from,
        to: this.to,
        perPage: this.pagination.perPage,
      });
    },
    isChecked(id) {
      if (this.mainJobModel.indexOf(id) !== -1) return true;
      return false;
    },
    search() {
      const params = {};
      Object.assign(params, this.searchParams);
      params.childOccupations = this.childJobModel;
      params.englishSkills = this.englishSkillModel;
      params.status = this.statusModel;
      params.regcompany = this.companyModel;
      params.client_color = this.colorModel;
      params.scoutHope = this.scoutHope;
      if (params.childOccupations.length === 0) delete params.childOccupations;
      if (params.englishSkills.length === 0) delete params.englishSkills;
      this[mutations.applicant.CHANGE_SEARCH_PARAMS](params);
      this.overflowState = 0;
    },
  },
  watch: {
    reloadApplicants: function() {
      // console.log(this.page);
      if (this.page === 1) {
        this.load(this.buildParams(1));
      } else {
        this.load(this.buildParams(this.page));
      }
    },
    applicantStatusToFilter: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    activeCategory(categories) {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    favoritesOnly: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    interviewsOnly: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    searchParams: function() {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // eslint-disable-next-line
    page: function(currentPage) {
      this.load(this.buildParams(currentPage));
    },
    // eslint-disable-next-line
    sortBy: function(value) {
      if (this.page === 1) this.load(this.buildParams(1));
      else this.setPage(1);
    },
    // mainJobModel(mainJobs) {
    //   this.updateMainJobModel({mainJobs});
    // },
  },
};
</script>
<style scoped>
thead {
  border-bottom: 1px solid #787878;
}
.client-listing-detail table th a {
  color: #036d6c;
  font-size: 12px;
  text-decoration: none !important;
}

.color-th >>> .btn {
  min-width: 10px !important;
}

.color-th >>> .dropdown-menu {
  min-width: 150px;
}
.arrow-link i {
  color: #d0c2c2;
}
.arrow-link i.active {
  color: #036d6c;
}
.reviewer {
  background: none !important;
  color: #036d6c;
  border: none !important;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 0 5px 0;
}
.reviewer:hover {
  background: none !important;
  color: #036d6c !important;
}
.th-dropdown-text {
  display: inline-block;
  min-width: 180px; /* or your desired width */
}

.th-dropdown >>> .btn {
  color: #026c6c !important;
  font-size: 14px !important;
}

tbody tr {
  cursor: pointer;
  border: 2px;
}
th.arrow-link:hover {
  cursor: pointer;
  padding: 5px 7px !important;
}

.table-responsive {
  overflow-x: visible;
}

tbody tr {
  cursor: pointer;
  border: 2px;
}
th.arrow-link:hover {
  cursor: pointer;
  padding: 5px 7px !important;
}

/* Ensure text wraps properly */
.table td, .table th {
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

/* Line clamp for text truncation */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
